import { useCallback, useState } from 'react'
import ApiClient from '../../../services/api/ApiClient'
import { showToast } from '../../shared/Toast'

const SUCCESS_MSG = 'L’export du tableau des alertes a bien été effectué.'
const ERROR_MSG = 'Une erreur est survenue lors de l’export.'

// Callers pass the scope-appropriate URL; the hook only owns the async lifecycle.
const useIssueExport = toastContainerId => {
  const [exporting, setExporting] = useState(false)

  const exportTo = useCallback(async url => {
    if (exporting)
      return
    setExporting(true)
    try {
      await ApiClient.get(url)
      showToast(SUCCESS_MSG, 'success', toastContainerId)
    } catch {
      showToast(ERROR_MSG, 'error', toastContainerId)
    } finally {
      setExporting(false)
    }
  }, [toastContainerId, exporting])

  return { exportTo, exporting }
}

export default useIssueExport
